module.exports = __webpack_public_path__ + "img/icon_app_off.29afac31.svg";